import CrewTransferMenu from "src/components/pages/Management/CrewTransfer/CrewTransferMenu";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "src/styled";

const CrewTransfer = () => {
  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <CrewTransferMenu />
    </PageContainer>
  );
};
export default CrewTransfer;
